import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LoaderWrapper } from "./index";
import DashboardPage from "./DashboardPage";
import DashboardPage_new from "./DashboardPage_new";
import TermsConditions from "./TermsConditions";
import { toast } from "react-toastify";
import { getApplicationStageNew } from "../services/api";
import axios from "axios";
import { encryptText, encryptAppId } from "../utils/encryption";

const DashboardRouteHandler = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [hasStage, setHasStage] = useState(false);
  const [hasTerm, setHasTerm] = useState(0);
  const [error, setError] = useState("");
  const [agreementData, setAgreementData] = useState(null);

  // Get user info from localStorage
  const orgId = localStorage.getItem("orgId") || "";
  const appId = localStorage.getItem("appId") || "";
  const labTypeId = localStorage.getItem("labTypeId") || "";

  useEffect(() => {
    if (!orgId || !appId) {
      toast.error(
        "Organization or Application information not found. Please login again."
      );
      navigate("/login");
      return;
    }
    checkApplicationStage();
  }, [orgId, appId, navigate]);

  const loadAgreement = async () => {
    if (!appId || !orgId) return false;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/assessor-logistic/agreement/${orgId}/${appId}`
      );
      if (response.data.success) {
        return response.data.data.IsDO===true;
      } 
    } catch (err) {
      console.error('Error loading agreement:', err);
    }
    return false;
  };

  //main/assessor-logistics-agreement
  const checkApplicationStage = async () => {
    try {
      setLoading(true);

      const stageResponse = await getApplicationStageNew(appId);
    
      const termCheck = stageResponse?.data?.istermCheck || 0;
      const PPPFFLScheme = stageResponse?.data?.PPPFFLScheme || 0;
      setHasTerm(termCheck);

      if (
        stageResponse?.data?.success &&
        stageResponse?.data?.stage !== null &&
        stageResponse?.data?.stage !== ""
      ) {
        const agreementStatus = await loadAgreement();
        if (!agreementStatus) {
           navigate(`/main/assessor-logistics-agreement?appId=${encryptAppId(appId )}&orgId=${encryptText(orgId)}`,{ replace: true });
          return;
        }
        setHasStage(true);
      } else {
        redirectToApplicationForm(termCheck, PPPFFLScheme);
      }
    } catch (err) {
      console.error(err);
      setError("Unable to fetch application stage.");
      redirectToApplicationForm(0, 0);
    } finally {
      setLoading(false);
    }
  };

  const redirectToApplicationForm = (termCheck, PPPFFLScheme) => {
    let encryptedParams = "";

    if (appId && orgId) {
      const encryptedAppId = encryptAppId(appId);
      const encryptedOrgId = encryptText(orgId);
      const encryptedLabTypeId = encryptText(labTypeId);

      encryptedParams = `?appId=${encryptedAppId}&orgId=${encryptedOrgId}&labTypeId=${encryptedLabTypeId}`;
    }
   
    if (termCheck !== 1) {
      navigate(`/main/termsandconditions${encryptedParams}`);
      return;
    }

    if (labTypeId === "1") {
      navigate(`/main/testing/laboratory-details${encryptedParams}`);
    } else if (labTypeId === "2") {
      navigate(`/main/calibration/laboratory-details${encryptedParams}`);
    } else if (labTypeId === "3") {
      if (PPPFFLScheme === 1) {
        navigate(`/main/medical-ppp-ffl/laboratory-details${encryptedParams}`);
      }else {
        navigate(`/main/medical/laboratory-details${encryptedParams}`);
      }
    } else {
      navigate("/main/application-form");
    }
  };

  if (loading) {
    return (
      <LoaderWrapper
        loading={true}
        type="fullscreen"
        message="Checking application status..."
      />
    );
  }

  if (error) {
    return (
      <div>
        <p>{error}</p>
        <button onClick={() => navigate("/main/application-form")}>
          Continue to Application Form
        </button>
      </div>
    );
  }

  // If terms not accepted show old dashboard
  if (hasTerm !== 1) {
  navigate(`/main/termsandconditions?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}&labTypeId=${encryptText(labTypeId)}`)
  }

  // If stage available show new dashboard
  return hasStage ? <DashboardPage_new /> : null;
};

export default DashboardRouteHandler;